/**
 * TODO
 * - Accessibility where lacking / needed
 * - props validation
 */

import React from 'react';

import { translate } from '~l10n/client';

import { CopyableInputControl } from '~shared/components/CopyableInputControl';
import { Dialog } from '~shared/components/Dialog/Dialog';
import { Divider } from '~shared/components/Divider';
import ToggleSwitch from '~shared/components/ToggleSwitch/ToggleSwitch';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';

interface ShareDialogProps {
  isOpen: boolean;
  title: string;
  isSharingEnabled: boolean;
  socNumber: string;
  handleEnableSharing: ((args: unknown) => Promise<void>) | (() => void);
  isControlsDisabled: boolean;
  closeDialog: () => void;
  closeLabel?: string;
}

const ShareQuizDialog = ({
  ...props
}: ShareDialogProps): React.ReactElement => {
  const importLink = `${
    new String(window.location.href).split('/teacher')[0]
  }/teacher/#import-quiz/${props.socNumber}`;

  const appContext = useTeacherApplicationContext();

  return (
    <Dialog
      id="story-modal"
      open={props.isOpen}
      onClose={props.closeDialog}
      title={props.title}
      closeLabel={props.closeLabel}
    >
      <div className="text-base my-5">
        <div className="mb-5">
          <Divider />
        </div>
        <div className="h-auto mb-5 flex flex-row items-center justify-between">
          <div
            className={`h-auto flex flex-col gap-3 items-start transition-all duration-200 ease-in-out ${
              props.isSharingEnabled ? 'justify-between' : 'justify-center'
            }`}
          >
            <div className="min-w-32 font-700 font-display text-display text-blue-900 transition-all duration-200 ease-in-out sharing-label">
              {translate('Enable Sharing')}
            </div>
            <p className="font-400 text-base leading-8 text-blue-600 transition-all duration-200 ease-in-out">
              {translate(
                'Allows anyone with the link or code to directly import a copy of this quiz into their library.'
              )}
            </p>
          </div>
          <ToggleSwitch
            id="enable-sharing"
            data-testid="toggle-switch"
            size="default"
            onChange={props.handleEnableSharing}
            on={props.isSharingEnabled}
            disabled={props.isControlsDisabled}
            label={translate('Enable Sharing')}
          />
        </div>
        {props.isSharingEnabled && (
          <>
            <div className="flex flex-col gap-4">
              {appContext === TeacherApplicationContext.Socrative && (
                <CopyableInputControl
                  label={translate('Link')}
                  value={importLink}
                  data-testid="link-code"
                />
              )}
              <CopyableInputControl
                label={translate('Code')}
                value={`SOC-${props.socNumber}`}
                textInputClass="font-600"
                data-testid="soc-code"
              />
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
};

export { ShareQuizDialog };
